<div class="report-custom">
	<div class="report-custom-toggle text-16">
		<div class="dz-flex">
			<div>
				<dz-toggle-switch
					[toggleOn]="showCustomization"
					[toggleLabel]="'Include/Exclude Model Portfolios' | dcr : 'INCLUDE_EXCLUDE_MODELS_CUSTOMIZATION_HEADER'"
					(click)="toggleShowCustomization()"
					custom-tracking
					[track-event]="'pdf-customization:include-exclude-model-portfolios' + ':' + (!showCustomization ? 'on' : 'off')"
				>
				</dz-toggle-switch>
			</div>
		</div>
	</div>

	<div *ngIf="showCustomization" class="customization">
		<div *ngIf="!isCustomizationAvailable">
			<span dcrHTMLKey="NO_PDF_RISK_PROFILE_CUSTOMIZATION_AVAILABLE_MESSAGE" class="text-16">PDF Risk Profile Customization is currently not available</span>
		</div>
		<div *ngIf="isCustomizationAvailable">
			<section class="row custom-table-headers text-16-bold">
				<span class="col-1">
					<label class="dz-flex">
						<dz-checkbox
							[checked]="isToggleAll"
							(change)="toggleAll($event)"
							class="form-control"
							custom-tracking
							[track-event]="'pdf-customization:include-exclude-model-portfolios-all-sections-toggle' + ':' + (!isToggleAll ? 'on' : 'off')"
							name="toggleAll"
							[id]="'toggleAll'"
						></dz-checkbox>
					</label>
				</span>
				<span class="col-7 text-16-bold"><span dcrHTMLKey="ALL_MODEL_SELECTED_TOGGLE_LABEL">All Profiles</span></span>
			</section>

			<ng-container *ngFor="let section of categories; let sectionIndex = index">
				<section class="row custom-table-content">
					<span class="col-1">
						<dz-checkbox
							[checked]="section.checked"
							(change)="onSectionCheck(sectionIndex)"
							class="form-control"
							custom-tracking
							[track-event]="'pdf-customization:include-exclude-' + section.description + '-toggle'"
							[name]="section.description"
							[id]="section.id"
						></dz-checkbox>
					</span>

					<span class="col-7 text-15">
						<label [attr.for]="section.description">{{ section.description }}</label>
					</span>
				</section>
			</ng-container>
		</div>
	</div>
</div>
